import moment from 'moment';

const formatTooltipDate = (dateString, granularity) => {
  const date = moment(dateString);
  
  switch (granularity) {
    case 'weekly':
      const weekEnd = date.clone().endOf('week');
      return `Week of ${date.format('MMM DD')} - ${weekEnd.format('MMM DD, YYYY')}`;
    case 'monthly':
      return date.format('MMMM YYYY');
    case 'daily':
    default:
      return date.format('MMM DD, YYYY');
  }
};

const CustomTooltip = (props) => {
  const { active, payload, label, legendName, granularity } = props;
  if (active && payload && payload.length) {
    const unit = getUnit(legendName)
    const isUsage = legendName === 'Usage'
      || legendName === 'On-demand model API Usage'
      || legendName === 'Virtual Machine Usage'
      || legendName === 'Storage Usage';
    const isTokenUsage = legendName === 'Token Usage';
    const total = isUsage ? payload.reduce((s, c) => s += c.value, 0) : 0;
    return isUsage
      ? <div className="custom-tooltip">
        <p className="custom-tooltip__label">
          {`${label} | Total:$${Number(total).toFixed(2)}`}
        </p>
        {payload.map((p, i) => (
          <p key={i} className="custom-tooltip__value" style={{ color: p.color }}>
            {p.dataKey}: {isUsage ? '$' : ''}{p.value} {unit}
          </p>
        ))}
      </div> :
      isTokenUsage
        ? <div className="custom-tooltip">
          <p className="custom-tooltip__label">
            {`${label}`}
          </p>
          {payload.map((p, i) => (
            <p key={i} className="custom-tooltip__value" style={{ color: p.color }}>
              {p.dataKey}: {p.value} {unit}
            </p>
          ))}
        </div> : <div className="custom-tooltip">
          <p className="custom-tooltip__label">
            {formatTooltipDate(label, granularity)}
          </p>
          {payload.length > 1 ? (
            // Show all payload items when there are multiple (e.g., DAU and Total Users)
            payload.map((p, i) => {
              // Format the label nicely - use name from payload if available, otherwise fall back to dataKey mapping
              let displayName = p.name || (p.dataKey === 'result' ? legendName : 
                               p.dataKey === 'totalUsers' ? 'Total Users' : 
                               p.dataKey);
              return (
                <p key={i} className="custom-tooltip__value" style={{ color: p.color }}>
                  {displayName}: {isUsage ? '$' : ''}{p.value} {unit}
                </p>
              );
            })
          ) : (
            // Show single value when there's only one series
            <p className="custom-tooltip__value">
              {payload[0].name || legendName}: {isUsage ? '$' : ''}{payload[0].value} {unit}
            </p>
          )}
        </div>
  }

  return null;
};

const getUnit = (legendName) => {
  switch (legendName) {
    case 'URL Hits':
      return 'K hits';
    case 'URL Volume':
      return 'GB';
    case 'URL Viewers':
      return ''
    default:
      return '';
  }
}

export default CustomTooltip;